import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import parseQueryString from 'utils/routing'
import history from 'configureHistory'
import { authActions } from 'features/auth'

import { Button } from 'components'
import Form from './Form'

class RegisterPage extends Component {
	handleSubmit = values => {
		const { location, register } = this.props
		const inviteCode = location.state ? location.state.token : null

		if (inviteCode) {
			values = { ...values, inviteCode }
		}

		register(values)
	}

	render() {
		const { isVerified, location } = this.props

		const params = location.search
			? parseQueryString(location.search)
			: null

		const email = location.state ? location.state.email : ''
		const teamName = location.state ? location.state.teamName : ''
		const teamUrl = location.state ? location.state.teamUrl : ''
		const token = location.state ? location.state.token : null

		// if (!token && process.env.NODE_ENV === 'production') {
		// 	return (
		// 		<div className="u-center-inside-flex u-max-width--small">
		// 			<h1>
		// 				Sign up closed for now&nbsp;
		// 				<Button
		// 					layout="underlined-text"
		// 					text="Sign in to your account"
		// 					onClick={() => history.push('/login')}
		// 				/>
		// 			</h1>
		// 		</div>
		// 	)
		// }

		return (
			<Form
				initialValues={{
					team: teamName,
					teamUrl,
					email,
					voucherCode: params && params.v ? params.v : null,
				}}
				onSubmit={this.handleSubmit}
				isVerified={isVerified}
				isInvite={!!token}
				team={teamName}
			/>
		)
	}
}

RegisterPage.propTypes = {
	register: PropTypes.func.isRequired,
	isVerified: PropTypes.bool,
}

RegisterPage.defaultProps = {
	isVerified: null,
}

const mapDispatchToProps = {
	register: authActions.registerRequest,
}

const mapStateToProps = state => ({ isVerified: state.auth.isVerified })

export default connect(mapStateToProps, mapDispatchToProps)(RegisterPage)
